<template>
  <div class="py-8">
    <v-form ref="form" v-if="form" class="provider-form">
      <label class="text-field-label">Provider Name</label>
      <v-text-field
        flat
        solo
        required
        class="mt-2"
        v-model="form.name"
        :error-messages="form.$getError('name')"
        :loading="loading"
      ></v-text-field>

      <label class="text-field-label">Link</label>
      <v-text-field
        flat
        solo
        required
        class="mt-2"
        v-model="form.link"
        :error-messages="form.$getError('link')"
        :loading="loading"
      >
      </v-text-field>

      <label class="text-field-label">Template</label>
      <v-autocomplete
        class="mt-2"
        flat
        solo
        v-model="selectedProviders"
        :items="templates"
        append-icon=""
        hide-no-data
        chips
        clearable
        deletable-chips
        multiple
        item-text="name"
        item-value="id"
        hide-selected
        :menu-props="menuProps"
        :search-input.sync="providerInput"
        @input="providerInput = null"
      >
        <template #selection="data">
          <v-chip
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            @click="data.select"
            @click:close="remove(data.item)"
          >
            {{ data.item.name }}
          </v-chip>
        </template>
        <template #item="{ item }">
          {{ item.name }}
        </template>
      </v-autocomplete>
      <div class="mt-4 d-flex flex-row">
        <v-btn
          color="light"
          class="mr-4 px-6"
          height="40px"
          width="50%"
          @click="$router.replace('/providers')"
          :disabled="form.$busy"
          >Cancel</v-btn
        >
        <v-btn
          color="primary"
          class="mr-4 px-6"
          height="40px"
          width="50%"
          :loading="form.$busy"
          @click="provider ? editProvider() : addProvider()"
          >Save</v-btn
        >
      </div>
    </v-form>
    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { each } from 'lodash'

export default {
  props: {
    provider: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      loading: false,
      providerInput: null,
      menuProps: {
        closeOnContentClick: true,
        disableKeys: true,
        maxHeight: 304
      },
      selectedProviders: null
    }
  },

  computed: {
    ...mapState({
      form: state => state.provider.form,
      fetchedTemplates: state => state.provider.templates
    }),
    templates() {
      const items = []
      each(this.fetchedTemplates, provider => {
        items.push({ id: provider.id, name: provider.label })
      })
      return items
    }
  },

  methods: {
    ...mapActions({
      fetchTemplates: 'provider/getTemplates',
      createProvider: 'provider/createProvider',
      updateProvider: 'provider/updateProvider'
    }),

    initForm() {
      this.form.id = this.provider.id
      this.form.name = this.provider.name
      this.form.link = this.provider.link
      const items = []
      each(this.provider.categories, provider => {
        items.push({ id: provider.id })
      })
      this.selectedProviders = items
    },

    addProvider() {
      this.form.categories = this.selectedProviders
      this.createProvider(this.form.$data())
        .then(() => {
          this.form.$busy = false
          this.$router.replace('/providers')
        })
        .catch(err => {
          this.form.$busy = false
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    },

    editProvider() {
      this.form.categories = this.selectedProviders
      this.updateProvider(this.form.$data())
        .then(() => {
          this.form.$busy = false
          this.$emit('show-snackbar', {
            message: 'Provider details successfully updated!',
            color: 'success'
          })
        })
        .catch(err => {
          this.form.$busy = false
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    },

    remove(item) {
      const index = this.selectedProviders.indexOf(item.id)
      if (index >= 0) {
        this.selectedProviders.splice(index, 1)
      }
    }
  },

  created() {
    this.form.$reset()
    this.fetchTemplates(1)
    if (this.provider) {
      this.initForm()
    }
  }
}
</script>
